import { onValue, ref } from 'firebase/database';

// Only the backend can write this public record. Its arrival acknowledges sync.
export const waitForJobPublication = (database, employerId, jobId, timeoutMs = 45000) =>
  new Promise((resolve, reject) => {
    let unsubscribe;
    let settled = false;
    const finish = (error) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      unsubscribe?.();
      if (error) reject(error);
      else resolve();
    };
    const timer = setTimeout(() => finish(new Error('publication-pending')), timeoutMs);
    try {
      unsubscribe = onValue(ref(database, `job_posts/${jobId}`), snapshot => {
        const job = snapshot.val();
        if (job?.published === true && job.employerId === employerId && job.jobId === jobId) finish();
      }, finish);
      if (settled) unsubscribe();
    } catch (error) {
      finish(error);
    }
  });
